<template>
    <div v-if="job && source && destination" @keyup.esc="$root.$emit('CLOSEBACKUPVIEW')" class="dialog draggable-item light bg-light w-100-sm w-100-md w-75-lg w-50-xl h-75" id="backupview">

        <div class="dialog-title pl-10">
            <div>
                <span class="col-11">{{ job.name }}</span>
                <span class="button square closer" @click="$root.$emit('CLOSEBACKUPVIEW')"></span>
            </div>
        </div>

        <div class="dialog-content w-100 overflow px-10">

            <div data-role="buttongroup " class="d-flex dialog-topmost flex-justify-end rounded">
                
                <button @click="runJob" :title="$t('Run')" class="button flat-button" :disabled="job.isRunning != 'NR'">
                    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5 5.274c0-1.707 1.826-2.792 3.325-1.977l12.362 6.726c1.566.853 1.566 3.101 0 3.953L8.325 20.702C6.826 21.518 5 20.432 5 18.726V5.274Z"
                            fill="#212121" />
                    </svg>
                </button>
                <button @click="pauseJob" :title="$t('Stop')" class="button  flat-button"
                    :disabled="job.isRunning != 'R'">
                    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4.75 3A1.75 1.75 0 0 0 3 4.75v14.5c0 .966.784 1.75 1.75 1.75h14.5A1.75 1.75 0 0 0 21 19.25V4.75A1.75 1.75 0 0 0 19.25 3H4.75Z"
                            fill="#212121" />
                    </svg>
                </button>
                <button @click="editJob" :title="$t('Edit')" class="button flat-button"
                    :disabled="job.isRunning != 'NR'">
                    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3 5.25A2.25 2.25 0 0 1 5.25 3h13.5A2.25 2.25 0 0 1 21 5.25v5.762a3.279 3.279 0 0 0-2.607.95L15.355 15H11.25a.75.75 0 1 0 0 1.5h2.605l-1.365 1.365a3.685 3.685 0 0 0-.97 1.712L11.166 21H5.25A2.25 2.25 0 0 1 3 18.75V5.25Zm4.75 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3.5-1.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Zm0 3.75a.75.75 0 1 0 0 1.5h5.5a.75.75 0 1 0 0-1.5h-5.5Zm-4.5.75a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm1 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm11.35-4.08-5.903 5.902a2.686 2.686 0 0 0-.706 1.247l-.458 1.831a1.087 1.087 0 0 0 1.319 1.318l1.83-.457a2.685 2.685 0 0 0 1.248-.707l5.902-5.902A2.286 2.286 0 0 0 19.1 12.67Z"
                            fill="#212121" />
                    </svg>
                </button>
                <button @click="$root.$emit('duplicateJob', job)" :title="$t('Duplicate')" class="button flat-button"
                    :disabled="job.isRunning == 'NA'">
                    <span class="mif-copy icon mif-2x"></span>
                </button>
                <button v-if="$ONEServiceTypeInfo[job.type].isRestoreActive" @click="configureRestoreJob" :title="$t('Restore')" class="button flat-button"
                    :disabled="job.isRunning != 'NR' || [$ResultValue.FeatureNotEnabled, $ResultValue.NeverExecuted].includes(job.last_result)">
                    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.207 2.543a1 1 0 0 1 0 1.414L5.414 5.75h7.836a8 8 0 1 1-8 8 1 1 0 1 1 2 0 6 6 0 1 0 6-6H5.414l1.793 1.793a1 1 0 0 1-1.414 1.414l-3.5-3.5a1 1 0 0 1 0-1.414l3.5-3.5a1 1 0 0 1 1.414 0Z"
                            fill="#212121" />
                    </svg>
                </button>

                <button @click="deleteJob" :title="$t('Delete')" class="button flat-button"
                    :disabled="job.isRunning != 'NR'">
                    <svg width="20" height="20" fill="none" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M21.5 6a1 1 0 0 1-.883.993L20.5 7h-.845l-1.231 12.52A2.75 2.75 0 0 1 15.687 22H8.313a2.75 2.75 0 0 1-2.737-2.48L4.345 7H3.5a1 1 0 0 1 0-2h5a3.5 3.5 0 1 1 7 0h5a1 1 0 0 1 1 1Zm-7.25 3.25a.75.75 0 0 0-.743.648L13.5 10v7l.007.102a.75.75 0 0 0 1.486 0L15 17v-7l-.007-.102a.75.75 0 0 0-.743-.648Zm-4.5 0a.75.75 0 0 0-.743.648L9 10v7l.007.102a.75.75 0 0 0 1.486 0L10.5 17v-7l-.007-.102a.75.75 0 0 0-.743-.648ZM12 3.5A1.5 1.5 0 0 0 10.5 5h3A1.5 1.5 0 0 0 12 3.5Z"
                            fill="#212121" />
                    </svg>
                </button>
                <button v-if="intoPCRoom" @click="$root.$emit('OPENEXPORTLOGSDIALOG', {'key': 'BACKUP', 'id':job.id, 'name':job.name})" :title="$t('Export logs')" class="flat-button"
                    :disabled="job.isRunning != 'NR'">
                    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" id="File-Export--Streamline-Unicons" height="16" width="16">
                        <path d="M14.995266666666666 10.838066666666666c-0.03966666666666666 -0.09499999999999999 -0.09546666666666666 -0.18246666666666667 -0.16466666666666666 -0.2587333333333333l-2.352 -2.352c-0.1476 -0.1476 -0.34786666666666666 -0.2305333333333333 -0.5566666666666666 -0.2305333333333333s-0.40900000000000003 0.08293333333333333 -0.5566 0.2305333333333333c-0.14766666666666667 0.14766666666666667 -0.23059999999999997 0.34786666666666666 -0.23059999999999997 0.5566666666666666s0.08293333333333333 0.40900000000000003 0.23059999999999997 0.5566666666666666l1.0191999999999999 1.0113333333333332h-4.3826c-0.20786666666666667 0 -0.4073333333333333 0.08266666666666667 -0.5543333333333333 0.22966666666666663s-0.22966666666666663 0.34639999999999993 -0.22966666666666663 0.5543333333333333c0 0.20793333333333333 0.08266666666666667 0.4074 0.22966666666666663 0.5544s0.3464666666666667 0.22959999999999997 0.5543333333333333 0.22959999999999997h4.3826l-1.0191999999999999 1.0113333333333332c-0.07346666666666667 0.07293333333333332 -0.13179999999999997 0.15966666666666665 -0.1716 0.2551333333333333 -0.03986666666666666 0.09559999999999999 -0.06033333333333333 0.19806666666666664 -0.06033333333333333 0.3015333333333333s0.020466666666666668 0.20593333333333333 0.06033333333333333 0.3015333333333333c0.0398 0.09546666666666666 0.09813333333333332 0.18219999999999997 0.1716 0.2551333333333333 0.07293333333333332 0.07346666666666667 0.1596 0.13179999999999997 0.2551333333333333 0.1716 0.09553333333333333 0.0398 0.19799999999999998 0.06026666666666666 0.30146666666666666 0.06026666666666666s0.206 -0.020466666666666668 0.3015333333333333 -0.06026666666666666c0.09553333333333333 -0.0398 0.18219999999999997 -0.09813333333333332 0.2551333333333333 -0.1716l2.352 -2.352c0.0726 -0.07366666666666666 0.1287333333333333 -0.16186666666666666 0.16466666666666666 -0.2587333333333333 0.0784 -0.19093333333333332 0.0784 -0.40493333333333337 0 -0.5958666666666667Zm-5.425333333333333 3.433933333333333h-6.271999999999999c-0.20793333333333333 0 -0.4073333333333333 -0.08259999999999999 -0.5543333333333333 -0.22959999999999997 -0.14706666666666665 -0.147 -0.22966666666666663 -0.3464666666666667 -0.22966666666666663 -0.5544V2.5119999999999996c0 -0.20793333333333333 0.08259999999999999 -0.4073333333333333 0.22966666666666663 -0.5544 0.147 -0.147 0.34639999999999993 -0.22959999999999997 0.5543333333333333 -0.22959999999999997h3.92V4.08c0 0.6237999999999999 0.24786666666666668 1.222 0.6889333333333334 1.6631333333333331 0.4410666666666666 0.4410666666666666 1.0393333333333332 0.6888666666666667 1.6630666666666667 0.6888666666666667h3.1359999999999997c0.1548 -0.0007999999999999999 0.3058666666666666 -0.047333333333333324 0.43426666666666663 -0.13386666666666666 0.12833333333333333 -0.08646666666666666 0.22826666666666665 -0.20906666666666665 0.28706666666666664 -0.35219999999999996 0.06 -0.14279999999999998 0.0764 -0.3001333333333333 0.04706666666666666 -0.4522 -0.029199999999999997 -0.15213333333333331 -0.10293333333333334 -0.2921333333333333 -0.21173333333333333 -0.4024L8.558599999999998 0.3873333333333333c-0.06486666666666666 -0.060933333333333325 -0.13893333333333333 -0.11126666666666665 -0.2195333333333333 -0.1489333333333333h-0.07053333333333334L8.049 0.15999999999999998H3.2979333333333334c-0.6237333333333333 0 -1.222 0.24779999999999996 -1.6630666666666667 0.6888666666666667 -0.44113333333333327 0.44113333333333327 -0.6889333333333334 1.0393333333333332 -0.6889333333333334 1.6631333333333331v10.975999999999999c0 0.6237333333333333 0.24779999999999996 1.222 0.6889333333333334 1.6631333333333331 0.4410666666666666 0.4410666666666666 1.0393333333333332 0.6888666666666667 1.6630666666666667 0.6888666666666667h6.271999999999999c0.20793333333333333 0 0.4074 -0.08259999999999999 0.5544 -0.22959999999999997s0.22959999999999997 -0.3464666666666667 0.22959999999999997 -0.5544c0 -0.20793333333333333 -0.08259999999999999 -0.4073333333333333 -0.22959999999999997 -0.5543333333333333s-0.3464666666666667 -0.22966666666666663 -0.5544 -0.22966666666666663Zm-0.7839999999999999 -11.438533333333334 2.0305999999999997 2.030533333333333h-1.2466c-0.20786666666666667 0 -0.4073333333333333 -0.08259999999999999 -0.5543333333333333 -0.22959999999999997 -0.147 -0.14706666666666665 -0.22966666666666663 -0.3464666666666667 -0.22966666666666663 -0.5544V2.833466666666667Z" fill="#000000" stroke-width="0.6667"></path>
                    </svg>                
                </button>
            </div>
            
            <ul data-role="materialtabs"  id="backupView_tabs" data-expand="true"
                class="bg-transparent text-small p-0 tabs-material" style="z-index: 1;">
                <li class="d-flex flex-align-center mt-0 pt-0 active">
                    <a href="#overview">{{ $t("Overview") }}</a>
                </li>
                <li class="d-flex flex-align-center mt-0 pt-0 active">    
                    <a href="#source_destination">{{ $t("Sources and destinations") }}</a>
                </li>
                <li class="d-flex flex-align-center mt-0 pt-0 active">
                    <a href="#logs">{{ $t("Last logs") }}</a>
                </li>
            </ul>
            
            <!----------------------INFORMAZIONI PRINCIPALI------------------------------->
            <div id="overview" class="cell">
                <table class="table rounded  small striped bg-white m-0">
                    <tbody>
                        <tr>
                            <td>{{ $t("ID") }}:</td>
                            <td class="text-bold">{{ job.id }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("Computer name") }}:</td>
                            <td v-if="pcName" class="text-bold">{{ pcName }}</td>
                        </tr>

                        <tr>
                            <td>{{ $t("Created at") }}:</td>
                            <td>{{ (job.inserted_at == null ? "" : convertDate(job.inserted_at)) }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("Updated at") }}</td>
                            <td>{{ (job.updated_at == null ? "" : convertDate(job.updated_at)) }}</td>
                        </tr>
                        <tr
                            v-if="isValid(job.last_result) && job.last_result != $ResultValue.NeverExecuted">
                            <td>{{ $t("Started at") }}</td>
                            <td>{{ (job.dt_start_utc == null ? "" : convertDate(job.dt_start_utc)) }}</td>
                        </tr>
                        <tr
                            v-if="isValid(job.last_result) && job.last_result != $ResultValue.NeverExecuted">
                            <td>{{ $t("Ended at") }}</td>
                            <td>{{ (job.dt_end_utc == null ? "" : convertDate(job.dt_end_utc)) }}</td>
                        </tr>
                        <tr v-if="job.isRunning != undefined">
                            <td>{{ $t("Is running") }}</td>
                            <td v-if="job.isRunning == 'NA'"> {{ $t("Information not available") }}</td>
                            <td v-else-if="job.isRunning == 'R'"> {{ $t("Yes") }}</td>
                            <td v-else class="text-bold"> {{ $t("No") }}</td>
                        </tr>
                        <tr v-if="job.isRunning == 'R'">
                            <td>{{ $t("Current operation") }}</td>
                            <td>{{ job.current_operation }}</td>
                        </tr>
                        <tr v-if="job.isRunning == 'R'">
                            <td>{{ $t("Progress") }}</td>
                            <td>{{ job.progress }} %</td>
                        </tr>
                        <tr v-if="job.isRunning == 'R'">
                            <td>{{ $t("Processed data") }}</td>
                            <td class="no-wrap">{{ job.processed_data_string }} </td>
                        </tr>
                        <tr v-if="job.last_result != 99">
                            <td>{{ $t("Copied files") }}</td>
                            <td>{{ job.last_backup_copiedfiles }}</td>
                        </tr>
                        <tr v-if="job.last_result != 99">
                            <td>{{ $t("Backup size") }}</td>
                            <td>{{ prettyBytes(job.last_backup_size) }}</td>
                        </tr>
                        <tr
                            v-if="job.isRunning != 'R' && isValid(job.last_result) && job.last_result != $ResultValue.NeverExecuted">
                            <td>{{ $t("Last result") }}</td>
                            <td>
                                <LastResult :lastresult="job.last_result" :withLabel="true" />
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t("From") }}</td>
                            <td>{{ job.sources[0].type_name }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t("To") }} </td>
                            <td>{{ job.destinations[0].type_name }}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <!----------------------SORGENTI E DESTINAZIONI-------------------------------------------------->
            <div id="source_destination" class="cell small">
                <h3 class="fg-cobalt">{{ $t("Source") }}</h3>
                <h5 class="mt-4">{{ $t("Items") }}</h5>
                <SourceView :source="source" class="mt-4" />
                <!--<ObjectView :obj="source" />-->
                <h3 v-if="!['', '-2'].includes(source.id_service_account)" class="mt-4 fg-cobalt">{{ ($t("Source")) }} - {{ $t("Service account") }}</h3>
                <ObjectView v-if="!['', '-2'].includes(source.id_service_account)" :obj="$session.getServiceAccountWithID(source.id_service_account)" :withCopyButton="true" class="mt-4"/>
                
                <h5 class="mt-4">{{ $t("Options") }}</h5>
                <ObjectView :obj="source.options" class="mt-4" :withCopyButton="false"/>

                <h3 class="mt-4 fg-cobalt">{{ $t("Destination") }}</h3>
                <ObjectView :obj="destination" class="mt-4" :withCopyButton="false"/>
                <h5 v-if="!['', '-2'].includes(destination.id_repository)" class="mt-4 fg-cobalt"><span class="mif-folder-open mr-2"/><span>{{ ($t("Destination")) }} - {{ $t("Repository") }}</span></h5>
                <ObjectView v-if="!['', '-2'].includes(destination.id_repository)" :obj="$session.getRepositoryWithID(destination.id_repository)" :withCopyButton="false" class="mt-4"/>

                <h5 v-if="!['', '-2'].includes(destination.id_service_account)" class="mt-4 "><span class="mif-key mr-2"/><span>{{ ($t("Destination")) }} - {{ $t("Service account") }}</span></h5>
                <ObjectView v-if="!['', '-2'].includes(destination.id_service_account)" :obj="$session.getServiceAccountWithID(destination.id_service_account)" :withCopyButton="true" class="mt-4"/>

                <h3 class="mt-4 fg-cobalt">{{ $t("Scheduling") }}</h3>
                <div v-if="job.scheduling == null || job.scheduling.length == 0" class="mt-4">
                    <span class="mif-alarm"></span> {{ $t("No scheduling") }}
                </div>
                <div v-else >
                    <ul class="listview mt-4">
                        <li v-for="(sched, index) in job.scheduling" v-bind:key="index">
                            <label> <span class="mif-alarm"></span> {{ cronstrue.toString(sched, { locale: $i18n.locale, dayOfWeekStartIndexZero: false }) }}</label>
                        </li>
                    </ul>
                </div>
            </div>

            <!----------------------LOGS-------------------------------------------------------------->
            <div id="logs" class="cell">
                <div v-if="logs == null" class="h-100 d-flex flex-justify-center flex-align-center">
                    <span class="mif-spinner2 mif-4x fg-primary ani-spin" />
                </div>
                <NoDataAvailable class="w-100" v-else-if="logs.length == 0" :message="$t('No logs available')" />


                <table v-else class="table rounded striped bg-white">
                    <thead>
                        <tr>
                            <th class="w-10 text-center">{{ $t("Result") }}</th>
                            <th class="w-25">{{ $t("Start/End") }}</th>
                            <th>{{ $t("Duration") }}</th>
                            <th>{{ $t("Size") }}</th>
                            <th class="text-center">{{ $t("Num. Files") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="overflow"> 
                        <tr v-for="(log, index) in logs" :key="index">
                            <td >
                                <LastResult :lastresult="log.result" :progress="0" :isRunning="false"/> 
                            </td>
                            <td>
                                {{ convertDate(log.dt_start_utc) }} <br> 
                                {{ convertDate(log.dt_end_utc) }}
                            </td>
                            <td>{{ diffDate(log.dt_start_utc, log.dt_end_utc) }}</td>
                            <td>{{ prettyBytes(log.backup_size) }}</td>
                            <td class="text-center">{{ log.copied_files }}</td>
                            <td class="text-center">
                                <span v-if="log.partial_log == 'wait'" class="mif-spinner2 fg-primary ani-spin" />
                                <a v-else href="#" :disabled="log.partial_log == null" class="fg-black" @click="getPartialLog(index)">
                                    <span class="mif-log-file mif-2x" />
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>    
            </div>

        </div>

       

    </div>
</template>

<script>

import LastResult from "../../utils/LastResult.vue";
import NoDataAvailable from "../../utils/NoDataAvailable.vue";
import { isValid, prettyBytes, diffDate, assignProperties } from "../../../utils/utilitiesmodule";
import SourceView from './SourceView';
import ObjectView from './ObjectView';
import { draggableMixin } from '../../../mixins/draggable-mixin';


export default {
    name: "BackupView",
    props: {
        job: Object
    },
    components: {
        "LastResult": LastResult,
        NoDataAvailable,
        SourceView,
        ObjectView
    },
    mixins: [draggableMixin],

    data() {
        return {
            //job: null,
            pcName: null,

            logs: null,

            source: null,
            destination: null,

            intoPCRoom: false,
        }
    },

    async beforeDestroy() {
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        this.$root.$off("sendRealtimeJob");
        //this.$root.$off("addBackupsToPage");

        //Se sono nella pagina del computer, non devo far nulla
        if (this.intoPCRoom) {
            return;
        }

        // Se sto chiudendo per aprire la dialog di restore, preservo la room
        if (this.$root.__preservePCRoomOnClose) {
            // opzionale: pulisco il flag subito dopo
            this.$root.__preservePCRoomOnClose = false;
            return;
        }        

        //Altrimenti è stata istanziata una connessione socket per il pc del job, quindi devo stoppare
        this.$root.stopToListenPC(this.job.id_computer);


    },

    async created() {
        this.intoPCRoom=this.$route.path.contains(this.job.id_computer);
        if(!this.intoPCRoom){
            await this.$root.startToListenPC(this.job.id_computer);
        }
        //this.$store.commit('SET_LAYOUT', 'nav-layout');
        this.cronstrue=require('cronstrue/i18n');

        let self=this;
        self.source=self.job.sources[0];
        self.destination=self.job.destinations[0];

        var pc=self.$session.getRoomPC(); // roompc impostato da startToListenPC
        self.pcName=pc?.pc_name;
        this.getLogs();

        
        /*self.$root.$on("sendRealtimeJob", realtimeJob => {
            self.job.isRunning=realtimeJob.isRunning? "R":"NR";
            self.job.progress=realtimeJob.isRunning? realtimeJob.progress:null;
            self.job.current_operation=realtimeJob.current_operation;
            self.job.processed_data_string=realtimeJob.processed_data_string;
            self.job.last_result=realtimeJob.lastresult;
        });*/

        self.$root.$on("SETPAGEPROP", (prop, realtimeJob) => {
            if(prop!="job"){
                return;
            }
            
            assignProperties(realtimeJob, self.job, false);
        });

        //####################################################################

    },
    methods: {
        /******************************************BOTTONI*********************************/
        runJob() {
            let self=this;
            this.$root.$on("runJob_feedback", feedback => {

                if (feedback.status==self.$ResultValue.OK) {
                    self.job.isRunning="R";
                }


                if (feedback.status==self.$ResultValue.Error) {
                    self.job.isRunning="NR";
                }

                if (feedback.status!=self.$ResultValue.Running) {
                    self.$root.$off("runJob_feedback");
                    return;
                }

            });

            this.$root.$emit("runJob", this.job);
        },
        pauseJob() {
            let self=this;
            this.$root.$on("pauseJob_feedback", feedback => {

                if (feedback.status==self.$ResultValue.OK) {
                    self.job.isRunning="NR";
                }


                if (feedback.status==self.$ResultValue.Error) {
                    self.job.isRunning="R";
                }

                if (feedback.status!=self.$ResultValue.Running) {
                    self.$root.$off("pauseJob_feedback");
                    return;
                }

            });

            this.$root.$emit("pauseJob", this.job);
        },

        editJob() {
            this.$router.push("/computers/computer/"+this.job.id_computer+"/backup/"+this.job.id);
            this.$root.$emit("CLOSEBACKUPVIEW");
        },
        /*renameJob() {
            this.$root.$emit("OPENRENAMEJOBDIALOG", this.job.id, this.job.name);
        },*/

        configureRestoreJob() {

            // let self=this;
            // this.$root.$on("restoreJob_feedback", feedback => {

            //     if (feedback.status==self.$ResultValue.OK) {
            //         this.$root.$emit("CLOSEBACKUPVIEW");
            //     }

            //     if (feedback.status!=self.$ResultValue.Running) {
            //         self.$root.$off("restoreJob_feedback");
            //         return;
            //     }

            // });

            this.$root.$emit("configureRestoreJob", this.job);

        },


        deleteJob() {

            let self=this;
            this.$root.$on("deleteJob_feedback", feedback => {

                if (feedback.status==self.$ResultValue.OK) {
                    this.$root.$emit("CLOSEBACKUPVIEW");
                }

                if (feedback.status!=self.$ResultValue.Running) {
                    self.$root.$off("deleteJob_feedback");
                    return;
                }

            });

            this.$root.$emit("deleteJob", this.job);

        },

        /*******************************LOGS**************************************************************/
        async getLogs() {
            let self=this;
            var logs=await this.$api.getBackupLogs(self.job.id, false);
            if (logs==null)
                self.logs=[];
            else
                self.logs=logs.map(l => { l.showPartialLog=false; return l; });
        },
        async getPartialLog(index) {
            let self=this;
            var isConnected=this.$root.connectionsStates[this.job.id_computer];

            //Socket non connesso + nessun partial log
            if (!isConnected) {

                if ( self.logs[index].partial_log!="") {
                    this.$root.$emit("OPENBACKUPLOG", self.logs[index].logfile_name);
                 
                }
               
            }else{

                //Socket connesso
                switch (self.logs[index].partial_log) {
                    case "wait"://richiesta del partial log in corso
                        break;
    
                    case null://richiesta non andata a buon fine
                    case "": // richiesta ancora non effettuata
                        self.logs[index].partial_log="wait";
                        self.$root.toast(self.$t("Getting log, please wait..."), "info");
                        //richiedo il partial log 
                        self.logs[index].partial_log=await this.$root.socket("GetHTMLBackupLog", self.logs[index].logfile_name);
                        if (self.logs[index].partial_log!=null) {
                            this.$root.$emit("OPENBACKUPLOG", self.logs[index].partial_log);
                        }
    
                        break;
    
                    default:
                        //Se il log contiene il log parziale, richiedo il log totale
                        if (self.logs[index].partial_log.contains("THIS IS PARTIAL LOG")) {
                            var htmlLogFromSocket=await this.$root.socket("GetHTMLBackupLog", self.logs[index].logfile_name);
                            if (htmlLogFromSocket!=null) {
                                self.logs[index].partial_log=htmlLogFromSocket;
                            }
                        }
    
                        this.$root.$emit("OPENBACKUPLOG", self.logs[index].partial_log);
                        break;
                }
            }



        },

        /*************************************UTILS******************************/
        /*retrieveDataFromSocket(pc) {
            let self=this;
            //Se non sono in una stanza del pc, devo instanziare la connessione socket
            self.$session.setRoomPC(pc);
            this.$root.socket("SETPC", pc);

            this.$root.$on("addBackupsToPage", backups_received => {
                if (backups_received[self.job.id]==undefined) {
                    return;
                }
                self.job.isRunning=backups_received[self.job.id].isRunning? "R":"NR";
                self.job.progress=backups_received[self.job.id].isRunning? backups_received[self.job.id].progress:null;
                self.job.current_operation=backups_received[self.job.id].current_operation;
                self.job.processed_data_string=backups_received[self.job.id].processed_data_string;
                self.job.last_result=backups_received[self.job.id].lastresult;
            });

            self.$root.socket("subscribe_pc", self.job.id_computer)
                .then(() => {
                    //console.log(new Date());
                    self.$root.socket("STARTSENDINFO");
                });
        },*/



        convertDate(date) {
            if(!isValid(date))
                return "";
            if (date.toString().indexOf("T")==-1)
                date=this.$moment(date.substr(0, 8)+"T"+date.substr(8), "LLL");

            if (date.toString().indexOf("Z")!=-1)
                date=date.replace("Z", "");

            return this.$moment.utc(date).local().format("LLL");
        },

        diffDate(datestart, dateend) {
            return diffDate(datestart, dateend, this.$moment);
        },

        prettyBytes(data) {
            return prettyBytes(data);
        },



        isValid(value) {
            return isValid(value);
        },

    }
}

</script>
